import { render, staticRenderFns } from "./trainingcategory.vue?vue&type=template&id=0b4eeb71&scoped=true&lang=pug"
import script from "./trainingcategory.vue?vue&type=script&lang=js"
export * from "./trainingcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eeb71",
  null
  
)

/* custom blocks */
import block0 from "./trainingcategory.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports